const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 666 377",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.86,116.696L73.642,154.695",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.411,277.434L73.642,154.695",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: "2.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.086,95.497L212.686,187.094",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.535,109.097L186.086,95.497",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.975,230.354L186.086,95.497",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.535,109.097L329.975,230.354",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: "5.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.975,230.354L212.686,188.094",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.686,188.094L148.307,277.434",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: "2.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.307,277.434L26.891,254.692",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8,350.689L149.411,277.434",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: "2.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.474,335.889L149.411,277.434",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: "2.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.535,109.097L453.292,174.412",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: "5.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.975,230.354L149.411,277.434",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: "5.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.975,230.354L477.474,335.889",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.292,174.412L329.975,230.354",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: "5.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.474,335.889L453.292,174.412",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: "5.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.474,335.889L610.069,247.892",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.139,99.497L453.292,174.412",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.164,18.699L566.139,99.497",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.775,96.697L566.139,99.497",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: "2.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.069,247.892L566.139,99.497",
    style: {
      fill: "none",
      stroke: "rgb(34,30,32)",
      strokeOpacity: 0.0784314,
      strokeWidth: "2.67px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,0.799975,0.806052,0,-182.28,83.0974)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 317.5,
    r: 21.5,
    style: {
      fill: "url(#_Linear1)",
      stroke: "white",
      strokeWidth: "3.74px",
      strokeLinecap: "butt",
      strokeMiterlimit: 1.41421
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,0.986064,0.993556,0,-129.368,7.24424)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 317.5,
    r: 21.5,
    style: {
      fill: "url(#_Linear2)",
      stroke: "white",
      strokeWidth: "3.03px",
      strokeLinecap: "butt",
      strokeMiterlimit: 1.41421
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,2.1898,2.20643,0,-370.568,34.3666)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 317.5,
    r: 21.5,
    style: {
      fill: "url(#_Linear3)",
      stroke: "white",
      strokeWidth: "1.36px",
      strokeLinecap: "butt",
      strokeMiterlimit: 1.41421
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,2.1898,2.20643,0,-359.008,-86.8904)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 317.5,
    r: 21.5,
    style: {
      fill: "url(#_Linear4)",
      stroke: "white",
      strokeWidth: "1.36px",
      strokeLinecap: "butt",
      strokeMiterlimit: 1.41421
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,2.1898,2.20643,0,-247.251,-21.5747)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 317.5,
    r: 21.5,
    style: {
      fill: "url(#_Linear5)",
      stroke: "white",
      strokeWidth: "1.36px",
      strokeLinecap: "butt",
      strokeMiterlimit: 1.41421
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,0.799975,0.806052,0,123.214,-492.084)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 638.5,
    cy: 487.5,
    r: 21.5,
    style: {
      fill: "url(#_Linear6)",
      stroke: "white",
      strokeWidth: "3.74px",
      strokeLinecap: "butt",
      strokeMiterlimit: 1.41421
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,0.799975,0.806052,0,336.415,-547.683)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 805.5,
    cy: 390,
    rx: 17,
    ry: 16.5,
    style: {
      fill: "url(#_Linear7)",
      stroke: "white",
      strokeWidth: "3.74px",
      strokeLinecap: "butt",
      strokeMiterlimit: 1.41421
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,0.799975,0.806052,0,-43.6389,337.489)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 72.5,
    r: 16.5,
    style: {
      fill: "url(#_Linear8)",
      stroke: "white",
      strokeWidth: "3.74px",
      strokeLinecap: "butt",
      strokeMiterlimit: 1.41421
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,0.799975,0.806052,0,448.053,-356.089)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 755,
    cy: 201,
    r: 17,
    style: {
      fill: "url(#_Linear9)",
      stroke: "white",
      strokeWidth: "3.74px",
      strokeLinecap: "butt",
      strokeMiterlimit: 1.41421
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,0.799975,0.806052,0,-10.5908,-22.4992)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 277,
    r: 17,
    style: {
      fill: "url(#_Linear10)",
      stroke: "white",
      strokeWidth: "3.74px",
      strokeLinecap: "butt",
      strokeMiterlimit: 1.41421
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,0.799975,0.806052,0,-128.274,229.493)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 192.5,
    r: 24.5,
    style: {
      fill: "url(#_Linear11)",
      stroke: "white",
      strokeWidth: "3.74px",
      strokeLinecap: "butt",
      strokeMiterlimit: 1.41421
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.58362,1.59565,0,-157.753,228.807)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 192.5,
    r: 24.5,
    style: {
      fill: "url(#_Linear12)",
      stroke: "white",
      strokeWidth: "1.89px",
      strokeLinecap: "butt",
      strokeMiterlimit: 1.41421
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.58362,1.59565,0,170.31,286.005)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 192.5,
    r: 24.5,
    style: {
      fill: "url(#_Linear13)",
      stroke: "white",
      strokeWidth: "1.89px",
      strokeLinecap: "butt",
      strokeMiterlimit: 1.41421
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.32241,1.33245,0,309.642,57.8411)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 192.5,
    r: 24.5,
    style: {
      fill: "url(#_Linear14)",
      stroke: "white",
      strokeWidth: "2.26px",
      strokeLinecap: "butt",
      strokeMiterlimit: 1.41421
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,0.799975,0.806052,0,-271.349,95.497)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 365,
    rx: 13,
    ry: 12.5,
    style: {
      fill: "url(#_Linear15)",
      stroke: "white",
      strokeWidth: "3.74px",
      strokeLinecap: "butt",
      strokeMiterlimit: 1.41421
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(428.29,686.605,691.821,-425.061,-87.6552,296.437)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(252,232,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(255,208,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(228,195,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(181,207,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(347.463,557.029,561.261,-344.844,5.81225,187.238)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(252,232,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(255,208,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(228,195,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(181,207,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(156.462,250.83,252.735,-155.283,-9.76852,193.63)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(252,232,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(255,208,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(228,195,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(181,207,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(156.462,250.83,252.735,-155.283,45.6051,188.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(252,232,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(255,208,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(228,195,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(181,207,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(156.462,250.83,252.735,-155.283,15.7778,137.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(252,232,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(255,208,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(228,195,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(181,207,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(428.29,686.605,691.821,-425.061,631.345,-82.563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(252,232,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(255,208,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(228,195,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(181,207,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear7",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(428.29,686.605,691.821,-425.061,700.845,-347.063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(252,232,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(255,208,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(228,195,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(181,207,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(428.29,686.605,691.821,-425.061,-405.655,124.437)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(252,232,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(255,208,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(228,195,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(181,207,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear9",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(428.29,686.605,691.821,-425.061,461.345,-485.563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(252,232,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(255,208,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(228,195,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(181,207,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear10",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(428.29,686.605,691.821,-425.061,44.3448,83.437)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(252,232,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(255,208,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(228,195,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(181,207,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear11",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(428.29,686.605,691.821,-425.061,-270.655,229.437)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(252,232,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(255,208,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(228,195,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(181,207,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear12",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(216.353,346.842,349.477,-214.722,-136.29,134.375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(252,232,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(255,208,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(228,195,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(181,207,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear13",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(216.353,346.842,349.477,-214.722,-172.408,-71.2226)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(252,232,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(255,208,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(228,195,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(181,207,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear14",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(259.089,415.354,418.509,-257.136,-33.9272,-189.859)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(252,232,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(255,208,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(228,195,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(181,207,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear15",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(428.29,686.605,691.821,-425.061,-103.155,406.937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(252,232,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "rgb(255,208,250)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(228,195,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(181,207,255)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkGraph);
export default __webpack_public_path__ + "static/media/network-graph.fd4e969941909bb4dcd989b1573fe56e.svg";
export { ForwardRef as ReactComponent };